/**
 * Formats string, array entries, or object keys whose value evaluates to true
 * into a single className
 * For example ["  one  two ", undefined, null, { three: false, four: true }]
 * return  "one two four"
 */

type TFormatClassName = (
  classNames:
    | string
    | Record<string, boolean | undefined>
    | Array<string | Record<string, boolean | undefined> | undefined>
    | undefined
    | null
) => string | undefined;

export const formatClassName: TFormatClassName = classNames => {
  if (classNames === undefined || classNames === null) {
    return;
  }

  let classes;

  if (Array.isArray(classNames)) {
    classes = classNames.map(className => formatClassName(className));
  } else if (typeof classNames === 'object') {
    classes = Object.entries(classNames).map(([cn, val]) => val && cn);
  } else if (typeof classNames === 'string') {
    classes = classNames.trim().split(' ');
  }

  if (classes) {
    classes = classes.filter(cn => cn).join(' ');

    if (!classes.length) {
      classes = undefined;
    }
  }

  return classes;
};
